var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.957,
    height: 17.957,
    viewBox: "0 0 17.957 17.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38119",
    "data-name": "Path 38119",
    d: "M8.979,0a8.979,8.979,0,1,0,8.979,8.978A8.979,8.979,0,0,0,8.979,0Zm1.373,13.881a1.369,1.369,0,0,1-2.737,0V7.917a1.369,1.369,0,0,1,2.737,0ZM8.979,5.429a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,8.979,5.429Z",
    fill: "#2179fe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/info-button.6c5c7380.svg";
export { ForwardRef as ReactComponent };